import { defineStyleConfig } from "@chakra-ui/react"

export const cardTheme = defineStyleConfig({
  baseStyle: props => ({
    container: {
      bg: props.colorMode === "light" ? "white" : "whiteAlpha.100",
      borderColor: props.colorMode === "light" ? "gray.200" : "gray.600",
    },
  }),
})
